module.exports = __webpack_public_path__ + "static/media/balanco.d9655472.jpeg";